// extracted by mini-css-extract-plugin
export default {"wrapper":"Navbar_wrapper__BJctk","transparent":"Navbar_transparent__Y3VFk"};